module.exports = __webpack_public_path__ + "static/media/avatar_sheep.d7db2fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_sheep.png
// module id = 396
// module chunks = 0